module.exports = __webpack_public_path__ + "static/media/ctt-express.43ec49f5.svg";